// Name suffix values matching the 534EZ form schema enum
export const NAME_SUFFIXES = ['Jr.', 'Sr.', 'II', 'III', 'IV'];

// Full-form CHARACTER_OF_SERVICE options
export const CHARACTER_OF_SERVICE_OPTIONS = [
  'Honorable',
  'General (Under Honorable Conditions)',
  'Other Than Honorable',
  'Bad Conduct Discharge',
  'Dishonorable Discharge',
  'Uncharacterized',
  'Entry Level Separation',
];

// Character of service abbreviations → canonical full-form label
export const CHARACTER_OF_SERVICE_ABBREV_MAP = {
  OTH: 'Other Than Honorable',
  BCD: 'Bad Conduct Discharge',
  DD: 'Dishonorable Discharge',
  ELS: 'Entry Level Separation',
};

// CAVE upload status sets used to gate secondary upload transitions
export const TERMINAL_STATUSES = new Set(['success', 'error', 'skipped']);
export const ACTIVE_SECONDARY_STATUSES = new Set([
  'pending',
  'processing',
  'fetching-artifacts',
  'downloading-artifacts',
  'success',
]);
export const RETRIABLE_SECONDARY_STATUSES = new Set(['error', 'skipped']);

// Hyphenated canonical PAY_GRADE values
export const PAY_GRADE_OPTIONS = [
  'O-1',
  'O-2',
  'O-3',
  'O-4',
  'O-5',
  'O-6',
  'O-7',
  'O-8',
  'O-9',
  'O-10',
  'E-1',
  'E-2',
  'E-3',
  'E-4',
  'E-5',
  'E-6',
  'E-7',
  'E-8',
  'E-9',
  'W-1',
  'W-2',
  'W-3',
  'W-4',
  'W-5',
];

// All valid separation codes
export const SEPARATION_CODES = [
  'B70',
  'B79',
  'BB',
  'BC',
  'BCR',
  'BD',
  'BDA',
  'BDG',
  'BDK',
  'BDT',
  'BDU',
  'BFD',
  'BFE',
  'BFS',
  'BFT',
  'BFV',
  'BFX',
  'BFY',
  'BFZ',
  'BHF',
  'BHJ',
  'BHK',
  'BJ',
  'BK',
  'BKA',
  'BKB',
  'BKC',
  'BKK',
  'BKL',
  'BKM',
  'BKN',
  'BKQ',
  'BKR',
  'BLC',
  'BLF',
  'BLM',
  'BM',
  'BML',
  'BMN',
  'BNB',
  'BNC',
  'BPC',
  'BPD',
  'BRA',
  'BRB',
  'BRC',
  'CA',
  'CB',
  'CBL',
  'CC',
  'CF',
  'CK',
  'CM',
  'CN',
  'CP',
  'CQ',
  'CR',
  'DA',
  'DB',
  'DCH',
  'DER',
  'DF',
  'DFS',
  'DG',
  'DK',
  'DKL',
  'DL',
  'DLC',
  'DM',
  'DN',
  'DS',
  'DT',
  'DU',
  'EA',
  'EB',
  'EE',
  'EJ',
  'EK',
  'EKD',
  'EL',
  'ELPAC',
  'EN',
  'EP',
  'EQ',
  'ER',
  'FA',
  'FB',
  'FBC',
  'FBD',
  'FBJ',
  'FBK',
  'FBL',
  'FC',
  'FCA',
  'FCB',
  'FCC',
  'FCF',
  'FCK',
  'FCM',
  'FCN',
  'FCP',
  'FCQ',
  'FCR',
  'FD',
  'FDB',
  'FDF',
  'FDG',
  'FDL',
  'FDM',
  'FE',
  'FF',
  'FFF',
  'FFT',
  'FFV',
  'FFW',
  'FG',
  'FGM',
  'FGP',
  'FGQ',
  'FH',
  'FHC',
  'FHG',
  'FI',
  'FJ',
  'FK',
  'FKD',
  'FL',
  'FM',
  'FN',
  'FND',
  'FO',
  'FP',
  'FQ',
  'FR',
  'FS',
  'FT',
  'FU',
  'FV',
  'FW',
  'FX',
  'FY',
  'FZ',
  'GA',
  'GB',
  'GC',
  'GCN',
  'GCR',
  'GDA',
  'GDG',
  'GDK',
  'GDL',
  'GDT',
  'GDU',
  'GFC',
  'GFD',
  'GFE',
  'GFN',
  'GFT',
  'GFV',
  'GFX',
  'GFY',
  'GFZ',
  'GGH',
  'GH',
  'GHF',
  'GHJ',
  'GHK',
  'GJ',
  'GJB',
  'GKA',
  'GKB',
  'GKC',
  'GKD',
  'GKE',
  'GKF',
  'GKG',
  'GKH',
  'GKK',
  'GKL',
  'GKM',
  'GKN',
  'GKQ',
  'GKR',
  'GKS',
  'GLB',
  'GLC',
  'GLF',
  'GLG',
  'GLH',
  'GLJ',
  'GLK',
  'GLL',
  'GM',
  'GMB',
  'GMC',
  'GMD',
  'GMF',
  'GMH',
  'GMJ',
  'GMK',
  'GML',
  'GMM',
  'GMN',
  'GMP',
  'GN',
  'GNB',
  'GNC',
  'GP',
  'GPB',
  'GPC',
  'GPD',
  'GQ',
  'GRA',
  'GRB',
  'GRC',
  'GU',
  'GX',
  'HBF',
  'HC',
  'HCR',
  'HD',
  'HDA',
  'HDF',
  'HDG',
  'HDK',
  'HDT',
  'HDU',
  'HF',
  'HFC',
  'HFD',
  'HFE',
  'HFT',
  'HFV',
  'HFX',
  'HFY',
  'HFZ',
  'HG',
  'HH',
  'HHF',
  'HHJ',
  'HJ',
  'HJB',
  'HK',
  'HKA',
  'HKB',
  'HKD',
  'HKE',
  'HKF',
  'HKG',
  'HKH',
  'HKJ',
  'HKK',
  'HKL',
  'HKM',
  'HKN',
  'HKQ',
  'HKR',
  'HLB',
  'HLC',
  'HLF',
  'HLG',
  'HLH',
  'HLJ',
  'HLK',
  'HLL',
  'HMB',
  'HMC',
  'HMD',
  'HMF',
  'HMG',
  'HMJ',
  'HMM',
  'HMN',
  'HMP',
  'HNB',
  'HNC',
  'HPC',
  'HPD',
  'HRA',
  'HRB',
  'HRC',
  'HWL',
  'JA',
  'JB',
  'JBB',
  'JBC',
  'JBD',
  'JBH',
  'JBK',
  'JBM',
  'JC',
  'JCC',
  'JCM',
  'JCP',
  'JCR',
  'JD',
  'JDA',
  'JDF',
  'JDG',
  'JDJ',
  'JDK',
  'JDL',
  'JDM',
  'JDN',
  'JDP',
  'JDR',
  'JDT',
  'JDU',
  'JE',
  'JEA',
  'JEB',
  'JED',
  'JEE',
  'JEH',
  'JEM',
  'JEN',
  'JEP',
  'JEQ',
  'JER',
  'JET',
  'JF',
  'JFA',
  'JFB',
  'JFC',
  'JFD',
  'JFE',
  'JFF',
  'JFG',
  'JFI',
  'JFL',
  'JFM',
  'JFN',
  'JFO',
  'JFP',
  'JFQ',
  'JFR',
  'JFS',
  'JFT',
  'JFU',
  'JFV',
  'JFW',
  'JFX',
  'JFY',
  'JFZ',
  'JG7',
  'JGA',
  'JGB',
  'JGC',
  'JGF',
  'JGH',
  'JHD',
  'JHE',
  'JHF',
  'JHJ',
  'JHK',
  'JHM',
  'JIV',
  'JJA',
  'JJB',
  'JJC',
  'JJD',
  'JJE',
  'JJF',
  'JKA',
  'JKB',
  'JKC',
  'JKD',
  'JKE',
  'JKF',
  'JKG',
  'JKH',
  'JKK',
  'JKL',
  'JKM',
  'JKN',
  'JKQ',
  'JKR',
  'JKV',
  'JLB',
  'JLC',
  'JLF',
  'JLG',
  'JLH',
  'JLJ',
  'JLK',
  'JLL',
  'JMB',
  'JMC',
  'JMD',
  'JMF',
  'JMG',
  'JMH',
  'JMJ',
  'JML',
  'JMM',
  'JMN',
  'JMP',
  'JNB',
  'JNC',
  'JND',
  'JNF',
  'JNG',
  'JPB',
  'JPC',
  'JPD',
  'JRA',
  'JRB',
  'JRC',
  'KA',
  'KAK',
  'KB',
  'KBD',
  'KBH',
  'KBJ',
  'KBK',
  'KBM',
  'KCA',
  'KCB',
  'KCC',
  'KCE',
  'KCF',
  'KCK',
  'KCM',
  'KCN',
  'KCO',
  'KCP',
  'KCQ',
  'KD',
  'KDB',
  'KDF',
  'KDG',
  'KDH',
  'KDJ',
  'KDK',
  'KDM',
  'KDN',
  'KDP',
  'KDQ',
  'KDR',
  'KDS',
  'KDT',
  'KDU',
  'KEA',
  'KEB',
  'KEC',
  'KEE',
  'KEN',
  'KF',
  'KFB',
  'KFD',
  'KFE',
  'KFF',
  'KFG',
  'KFH',
  'KFM',
  'KFN',
  'KFS',
  'KFT',
  'KFV',
  'KFX',
  'KFY',
  'KFZ',
  'KGF',
  'KGH',
  'KGL',
  'KGM',
  'KGN',
  'KGP',
  'KGQ',
  'KGS',
  'KGT',
  'KGU',
  'KGV',
  'KGX',
  'KHC',
  'KHD',
  'KHF',
  'KHK',
  'KK',
  'KKB',
  'KL',
  'KLG',
  'KLM',
  'KM',
  'KMN',
  'KN',
  'KNC',
  'KND',
  'KNF',
  'KNL',
  'KOG',
  'KOJ',
  'KQ',
  'KR',
  'KRA',
  'KRB',
  'KRC',
  'LBB',
  'LBC',
  'LBD',
  'LBH',
  'LBK',
  'LBM',
  'LCC',
  'LCN',
  'LCR',
  'LDG',
  'LDK',
  'LDL',
  'LDM',
  'LDN',
  'LDP',
  'LDR',
  'LED',
  'LER',
  'LET',
  'LFC',
  'LFD',
  'LFE',
  'LFF',
  'LFG',
  'LFH',
  'LFN',
  'LFR',
  'LFT',
  'LFV',
  'LFW',
  'LFX',
  'LFY',
  'LFZ',
  'LGA',
  'LGB',
  'LGC',
  'LGH',
  'LGJ',
  'LHD',
  'LHF',
  'LHH',
  'LHJ',
  'LHK',
  'LIF',
  'LLM',
  'LND',
  'LNF',
  'MBD',
  'MBH',
  'MBJ',
  'MBK',
  'MBM',
  'MBN',
  'MCA',
  'MCB',
  'MCC',
  'MCF',
  'MCK',
  'MCN',
  'MCQ',
  'MDB',
  'MDF',
  'MDG',
  'MDH',
  'MDJ',
  'MDL',
  'MDM',
  'MDN',
  'MDP',
  'MDR',
  'MDS',
  'MEB',
  'MEC',
  'MFA',
  'MFF',
  'MFG',
  'MGC',
  'MGH',
  'MGJ',
  'MGM',
  'MGO',
  'MGP',
  'MGQ',
  'MGR',
  'MGU',
  'MGX',
  'MHC',
  'MND',
  'MNF',
  'MOD',
  'MOJ',
  'NB',
  'NBD',
  'NBE',
  'NC',
  'ND',
  'NDB',
  'NDH',
  'NEF',
  'NET',
  'NVC',
  'PA',
  'PB',
  'PC',
  'PD',
  'PGU',
  'PKB',
  'PKD',
  'PKF',
  'QCK',
  'QFH',
  'RA',
  'RB',
  'RBB',
  'RBC',
  'RBD',
  'RBE',
  'RC',
  'RCC',
  'RDL',
  'RFJ',
  'RFK',
  'RHK',
  'RNC',
  'SBB',
  'SBC',
  'SBD',
  'SBE',
  'SCC',
  'SCN',
  'SEJ',
  'SEK',
  'SFE',
  'SFJ',
  'SFK',
  'SGB',
  'SGC',
  'SHK',
  'SNC',
  'TCC',
  'VBK',
  'VEJ',
  'VEK',
  'VFJ',
  'VFK',
  'VNF',
  'WEJ',
  'WEK',
  'WEQ',
  'WFJ',
  'WFK',
  'WFQ',
  'XBK',
  'XDM',
  'XET',
  'XND',
  'XOH',
  'XOP',
  'XOS',
  'YBK',
  'YCP',
  'YDA',
  'YDN',
  'YDT',
  'YDU',
  'YFA',
  'YFB',
  'YFC',
  'YFU',
  'YKG',
  'YND',
  'YPA',
  'YPB',
];
